import React, { useState } from 'react';
import { ShieldCheckIcon, GraduationCapIcon, BriefcaseIcon, CarIcon, HeartPulseIcon, TrendingUpIcon, HomeIcon, StethoscopeIcon, SmartphoneIcon, PlaneIcon, PlusIcon, SettingsIcon, CopyIcon, PowerIcon } from 'lucide-react';
export function ProductCatalogueModule({
  role
}: {
  role: string;
}) {
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const products = [{
    id: 'goalguard',
    name: 'GoalGuard',
    icon: ShieldCheckIcon,
    color: 'emerald',
    underwriter: 'Leadway Assurance',
    pricingEngine: 'Target Fund, Tenure, Rate',
    status: 'Active'
  }, {
    id: 'scholar',
    name: 'Future Scholar Fund',
    icon: GraduationCapIcon,
    color: 'emerald',
    underwriter: 'Leadway Assurance',
    pricingEngine: 'Rate Table Lookup (Age x Tenure)',
    status: 'Active'
  }, {
    id: 'income',
    name: 'Income Shield',
    icon: BriefcaseIcon,
    color: 'blue',
    underwriter: 'Anchor Insurance',
    pricingEngine: 'Fixed Flat Rate',
    status: 'Active'
  }, {
    id: 'auto',
    name: 'AutoGuard',
    icon: CarIcon,
    color: 'indigo',
    underwriter: 'AXA Mansard',
    pricingEngine: 'Fixed Flat Rate',
    status: 'Active'
  }, {
    id: 'legacy',
    name: 'Legacy Plan',
    icon: HeartPulseIcon,
    color: 'rose',
    underwriter: 'Leadway Assurance',
    pricingEngine: 'Rate Table Lookup (Age x Tenure)',
    status: 'Active'
  }, {
    id: 'freedom',
    name: 'Freedom Fund',
    icon: TrendingUpIcon,
    color: 'purple',
    underwriter: 'Stanbic IBTC',
    pricingEngine: 'Target Fund, Tenure, Rate',
    status: 'Active'
  }, {
    id: 'property',
    name: 'Property Shield',
    icon: HomeIcon,
    color: 'amber',
    underwriter: 'Cornerstone Insurance',
    pricingEngine: 'Fixed Flat Rate',
    status: 'Active'
  }, {
    id: 'wellness',
    name: 'Wellness Plan',
    icon: StethoscopeIcon,
    color: 'cyan',
    underwriter: 'Hygeia HMO',
    pricingEngine: 'Fixed Flat Rate',
    status: 'Active'
  }, {
    id: 'travel',
    name: 'TravelGuard',
    icon: PlaneIcon,
    color: 'slate',
    underwriter: 'Cornerstone Insurance',
    pricingEngine: 'Rate Table Lookup / Fixed Flat Rate',
    status: 'Inactive'
  }];
  return <div className="space-y-6" data-id="element-555">
      <div className="flex justify-between items-center" data-id="element-556">
        <div data-id="element-557">
          <h2 className="text-2xl font-bold text-[#0D3B3B]" data-id="element-558">
            Product Catalogue
          </h2>
          <p className="text-sm text-gray-500" data-id="element-559">
            Manage insurance products, pricing engines, and configurations.
          </p>
        </div>
        <button className="bg-[#0D3B3B] text-white px-4 py-2 rounded-xl font-bold text-sm flex items-center gap-2 hover:bg-[#092D2D] transition-colors" data-id="element-560">
          <PlusIcon className="w-4 h-4" data-id="element-561" /> Create Product
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-562">
        {products.map(product => <div key={product.id} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 hover:shadow-md transition-shadow" data-id="element-563">
            <div className="flex justify-between items-start mb-4" data-id="element-564">
              <div className={`w-12 h-12 rounded-xl bg-${product.color}-50 flex items-center justify-center text-${product.color}-600`} data-id="element-565">
                <product.icon className="w-6 h-6" data-id="element-566" />
              </div>
              <span className={`px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${product.status === 'Active' ? 'bg-emerald-100 text-emerald-700' : 'bg-gray-100 text-gray-600'}`} data-id="element-567">
                {product.status}
              </span>
            </div>
            <h3 className="font-bold text-[#0D3B3B] text-lg mb-1" data-id="element-568">
              {product.name}
            </h3>
            <p className="text-sm text-gray-500 mb-4" data-id="element-569">{product.underwriter}</p>

            <div className="bg-gray-50 rounded-xl p-3 mb-6" data-id="element-570">
              <p className="text-[10px] uppercase font-bold text-gray-400 tracking-wider mb-1" data-id="element-571">
                Pricing Engine
              </p>
              <p className="text-xs font-bold text-[#0D3B3B]" data-id="element-572">
                {product.pricingEngine}
              </p>
            </div>

            <div className="flex gap-2" data-id="element-573">
              <button onClick={() => setSelectedProduct(product)} className="flex-1 bg-gray-50 hover:bg-gray-100 text-[#0D3B3B] font-bold py-2 rounded-lg text-xs flex items-center justify-center gap-1.5 transition-colors border border-gray-200" data-id="element-574">
                <SettingsIcon className="w-3.5 h-3.5" data-id="element-575" /> Configure
              </button>
              <button className="p-2 bg-gray-50 hover:bg-gray-100 text-gray-500 rounded-lg border border-gray-200 transition-colors" data-id="element-576">
                <CopyIcon className="w-4 h-4" data-id="element-577" />
              </button>
              {role === 'Super Admin' && <button className={`p-2 rounded-lg border transition-colors ${product.status === 'Active' ? 'bg-rose-50 border-rose-100 text-rose-600 hover:bg-rose-100' : 'bg-emerald-50 border-emerald-100 text-emerald-600 hover:bg-emerald-100'}`} data-id="element-578">
                  <PowerIcon className="w-4 h-4" data-id="element-579" />
                </button>}
            </div>
          </div>)}
      </div>

      {/* Product Detail Modal (Simulated) */}
      {selectedProduct && <div className="fixed inset-0 bg-[#0D3B3B]/40 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-id="element-580">
          <div className="bg-white rounded-3xl w-full max-w-3xl max-h-[90vh] overflow-y-auto shadow-2xl" data-id="element-581">
            <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 flex justify-between items-center z-10" data-id="element-582">
              <div className="flex items-center gap-3" data-id="element-583">
                <div className={`w-10 h-10 rounded-xl bg-${selectedProduct.color}-50 flex items-center justify-center text-${selectedProduct.color}-600`} data-id="element-584">
                  <selectedProduct.icon className="w-5 h-5" data-id="element-585" />
                </div>
                <div data-id="element-586">
                  <h3 className="font-bold text-[#0D3B3B] text-lg" data-id="element-587">
                    {selectedProduct.name} Configuration
                  </h3>
                  <p className="text-xs text-gray-500" data-id="element-588">
                    {selectedProduct.underwriter}
                  </p>
                </div>
              </div>
              <button onClick={() => setSelectedProduct(null)} className="p-2 hover:bg-gray-100 rounded-full text-gray-500" data-id="element-589">
                <PlusIcon className="w-6 h-6 rotate-45" data-id="element-590" />
              </button>
            </div>
            <div className="p-6 space-y-6" data-id="element-591">
              <div className="grid grid-cols-2 gap-6" data-id="element-592">
                <div data-id="element-593">
                  <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-594">
                    Pricing Engine
                  </label>
                  <select className="w-full bg-gray-50 border border-gray-200 rounded-xl py-3 px-4 text-sm font-bold text-[#0D3B3B]" data-id="element-595">
                    <option data-id="element-596">{selectedProduct.pricingEngine}</option>
                    <option data-id="element-597">Target Fund, Tenure, Rate</option>
                    <option data-id="element-598">Rate Table Lookup (Age x Tenure)</option>
                    <option data-id="element-599">Rate Table Lookup (Age x Duration x Plan)</option>
                    <option data-id="element-600">Fixed Flat Rate</option>
                  </select>
                </div>
                <div data-id="element-601">
                  <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-602">
                    Underwriter
                  </label>
                  <select className="w-full bg-gray-50 border border-gray-200 rounded-xl py-3 px-4 text-sm font-bold text-[#0D3B3B]" data-id="element-603">
                    <option data-id="element-604">{selectedProduct.underwriter}</option>
                  </select>
                </div>
              </div>

              <div data-id="element-605">
                <h4 className="font-bold text-[#0D3B3B] mb-3 border-b border-gray-100 pb-2" data-id="element-606">
                  Eligibility Rules
                </h4>
                <div className="grid grid-cols-3 gap-4" data-id="element-607">
                  <div data-id="element-608">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-609">
                      Min Entry Age
                    </label>
                    <input type="number" defaultValue={18} className="w-full bg-gray-50 border border-gray-200 rounded-lg py-2 px-3 text-sm" data-id="element-610" />
                  </div>
                  <div data-id="element-611">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-612">
                      Max Entry Age
                    </label>
                    <input type="number" defaultValue={65} className="w-full bg-gray-50 border border-gray-200 rounded-lg py-2 px-3 text-sm" data-id="element-613" />
                  </div>
                  <div data-id="element-614">
                    <label className="block text-xs text-gray-500 mb-1" data-id="element-615">
                      Waiting Period (Days)
                    </label>
                    <input type="number" defaultValue={30} className="w-full bg-gray-50 border border-gray-200 rounded-lg py-2 px-3 text-sm" data-id="element-616" />
                  </div>
                </div>
              </div>

              <div className="flex justify-end gap-3 pt-6 border-t border-gray-100" data-id="element-617">
                <button onClick={() => setSelectedProduct(null)} className="px-6 py-2.5 rounded-xl font-bold text-gray-600 hover:bg-gray-100 transition-colors" data-id="element-618">
                  Cancel
                </button>
                <button className="px-6 py-2.5 rounded-xl font-bold bg-[#0D3B3B] text-white hover:bg-[#092D2D] transition-colors shadow-lg shadow-emerald-900/20" data-id="element-619">
                  Save Configuration
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}